import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const SateliteChannelIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "SateliteChannelIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M13.5464 11.2835L14.4505 10.3806C15.1061 10.6931 15.916 10.5797 16.4594 10.0364C17.1475 9.3482 17.1475 8.22849 16.4594 7.54029C15.7712 6.8521 14.6514 6.8521 13.9633 7.54029C13.4101 8.09344 13.3102 8.90629 13.6179 9.54926L12.7144 10.4516L8.13902 5.87621C7.9093 5.64645 7.53676 5.64645 7.307 5.87621C4.33387 8.84934 4.32528 13.6812 7.28056 16.6655L5.40409 21.2242H3.44478C3.11986 21.2242 2.85645 21.4876 2.85645 21.8125C2.85645 22.1374 3.11987 22.4008 3.44478 22.4008H12.8581C13.1831 22.4008 13.4465 22.1374 13.4465 21.8125C13.4465 21.4876 13.183 21.2242 12.8581 21.2242H11.0931V18.7595C13.5575 19.2927 16.223 18.593 18.1234 16.6926C18.3531 16.4629 18.3531 16.0903 18.1234 15.8606L13.5464 11.2835ZM14.7953 8.37227C15.0246 8.14294 15.3979 8.14286 15.6273 8.37227C15.8567 8.60168 15.8567 8.97492 15.6273 9.20429C15.3974 9.43417 15.0252 9.43425 14.7952 9.20429C14.5653 8.97433 14.5653 8.60223 14.7953 8.37227ZM6.67651 21.2242L9.01134 15.552C9.20875 15.0783 9.91646 15.2219 9.91646 15.733V21.2242H6.67651ZM11.0931 17.551V15.733C11.0931 14.8247 10.3541 14.0857 9.4458 14.0857C8.77863 14.0857 8.18174 14.4837 7.92421 15.1018L7.77489 15.4645C5.74855 13.0732 5.73712 9.54651 7.74174 7.14297L16.8568 16.258C15.2549 17.5966 13.1229 18.0777 11.0931 17.551Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.7886 4.21294C18.2212 2.64491 15.9052 1.98241 13.7445 2.48379C13.428 2.55725 13.231 2.87342 13.3044 3.18991C13.3779 3.50643 13.694 3.70357 14.0105 3.62998C15.7787 3.2196 17.6738 3.76173 18.9565 5.04496C20.0423 6.1302 20.5871 7.59665 20.4973 9.09992C20.4771 9.43802 20.7457 9.72336 21.0851 9.72336C21.394 9.72336 21.6532 9.48246 21.6719 9.17009C21.7812 7.34119 21.1222 5.54587 19.7886 4.21294Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.2761 4.77578C13.9596 4.84905 13.7623 5.16506 13.8356 5.48162C13.9089 5.79818 14.2248 5.99539 14.5414 5.92217C15.4997 5.70045 16.5431 5.95924 17.2914 6.70826C17.9124 7.32868 18.1966 8.15007 18.1478 8.96723C18.1276 9.30599 18.3969 9.59055 18.7356 9.59055C19.0445 9.59055 19.3038 9.34961 19.3224 9.03716C19.391 7.88293 18.9847 6.73677 18.1234 5.87623C17.0844 4.83621 15.6261 4.46337 14.2761 4.77578Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default SateliteChannelIcon;
